module.exports = __webpack_public_path__ + "img/firebase.0522ea20.svg";